const delay = (ms: number) =>
  new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });

export const PORTAL_AI_QUEUE_CONCURRENCY = 1;
export const PORTAL_AI_QUEUE_DELAY_MS = 250;
export const PORTAL_STORY_POLL_CONCURRENCY = 4;
export const PORTAL_STORY_POLL_DELAY_MS = 100;
export const PORTAL_SUPPLEMENTAL_FILES_CONCURRENCY = 4;

export const mapPortalTasksWithLimit = async <T, R>(
  items: T[],
  task: (item: T, index: number) => Promise<R>,
  options: { concurrency: number; delayMs?: number }
) => {
  const results: R[] = new Array(items.length);
  let nextIndex = 0;

  const workers = Array.from({ length: Math.min(options.concurrency, items.length) }, async () => {
    while (nextIndex < items.length) {
      const currentIndex = nextIndex;
      nextIndex += 1;
      results[currentIndex] = await task(items[currentIndex], currentIndex);

      if (options.delayMs && nextIndex < items.length) {
        await delay(options.delayMs);
      }
    }
  });

  await Promise.all(workers);
  return results;
};
